import { useApolloClient } from '@apollo/client/react'
import { createFileRoute } from '@tanstack/react-router'

import { CommentCreate } from '@web/src/features/comment/comment-create-edit/comment-create-edit'
import PostMenu from '@web/src/features/post/post-menu/post-menu'
import PostView from '@web/src/features/post/post-view/post-view'
import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'

export const Route = createFileRoute('/(auth)/(main-layout)/post/$postId')({
  component: PostPage,
  head: () =>
    seo({
      title: `Post | ${env.VITE_APP_NAME}`,
      description: 'Post Page',
      robots: robotsMetaForEnvironment({ all: 'nofollow' }),
      meta: [{ name: 'rating', content: 'adult' }],
    }),
})

function PostPage() {
  const { postId } = Route.useParams()
  const { cache } = useApolloClient()

  return (
    <div className="mx-auto w-full max-w-[90rem] px-0">
      <div className="mb-4 grid grid-cols-2 gap-3 px-2 md:grid-cols-4">
        <aside className="col-span-2 mt-0 md:col-span-1 md:mt-4">
          <PostMenu />
        </aside>
        <div className="col-span-2 mt-0 md:col-span-2 md:mt-4">
          <PostView
            centerChildren={
              <div className="w-full">
                <CommentCreate
                  onSubmit={() => {
                    cache.evict({ fieldName: 'commentsCursor' })
                  }}
                  postId={postId}
                  scrollIntoViewOnFocus={true}
                  scrollIntoViewOptions={{ behavior: 'smooth', block: 'center' }}
                />
              </div>
            }
            disableCreateComment={true}
            postId={postId}
          />
        </div>
        <div className="col-span-1 mt-0 md:mt-0" />
      </div>
    </div>
  )
}
